import { signal } from "@preact/signals-react"
import { GROUPED_BY } from "@constants"
import {CONTENT_TYPE} from "../constants";

export const repricingSearchText = signal('')
export const expandedFilters = signal(true)
export const typeTab = signal(GROUPED_BY.VIDEO_CONTENT)
export const contentType = signal(CONTENT_TYPE.BASIC_FUNCTIONS)